/*
  Recomendaciones de productos en el cart drawer.

  - Llama a /recommendations/products.json con el product_id del primer item del carrito.
  - Renderiza hasta 2 tarjetas pequeñas con imagen, nombre, precio y botón "Añadir".
  - Al añadir, dispara 'cart:build' para que el drawer se refresque.
  - Si el carrito está vacío o el API devuelve 0, oculta el bloque.
*/
(function () {
  var LIMIT = 6;
  var FALLBACK_COLLECTION = 'mas-vendidos-mujer';
  var pending = false;
  var recProducts = [];
  var currentIndex = 0;

  async function fetchCart() {
    try {
      var resp = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!resp.ok) return null;
      return await resp.json();
    } catch (e) {
      return null;
    }
  }

  async function fetchRecommendations(productId) {
    try {
      var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + LIMIT;
      var resp = await fetch(url, { credentials: 'same-origin' });
      if (!resp.ok) return null;
      return await resp.json();
    } catch (e) {
      return null;
    }
  }

  async function fetchFallbackCollection() {
    try {
      var resp = await fetch('/collections/' + FALLBACK_COLLECTION + '/products.json?limit=' + LIMIT, { credentials: 'same-origin' });
      if (!resp.ok) return [];
      var data = await resp.json();
      return data.products || [];
    } catch (e) {
      return [];
    }
  }

  function getProductImageUrl(product) {
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.src) return product.featured_image.src;
    }
    if (product.images && product.images.length) {
      var first = product.images[0];
      if (typeof first === 'string') return first;
      if (first && first.src) return first.src;
    }
    return '';
  }

  function getProductUrl(product) {
    return product.url || ('/products/' + product.handle);
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + value;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function normalizeLabel(name) {
    return String(name)
      .replace(/Selecciona la talla/gi, 'Talla')
      .replace(/Seleccionar talla/gi, 'Talla')
      .replace(/Talla del calzado/gi, 'Talla')
      .replace(/Talle/gi, 'Talla');
  }

  function buildVariantSelectors(product) {
    if (!product.options || product.options.length === 0) return '';

    // product.options puede venir como ["Color","Talla"] o [{name,position,values},...]
    // según el endpoint. Normalizamos a un array de strings con los nombres.
    var optionNames = product.options.map(function (o) {
      return (typeof o === 'string') ? o : (o && o.name) || '';
    });

    if (optionNames.length === 1 && (optionNames[0] === 'Title' || optionNames[0] === 'Default Title' || optionNames[0] === '')) return '';

    return optionNames.map(function (optionName, optionIndex) {
      var values = [];
      product.variants.forEach(function (v) {
        var val = v.options[optionIndex];
        if (val && values.indexOf(val) === -1) values.push(val);
      });

      var label = escapeHtml(normalizeLabel(optionName));
      var selectHtml = '<select class="cart-rec-card__select" data-option-index="' + optionIndex + '" aria-label="' + label + '">';
      values.forEach(function (val) {
        selectHtml += '<option value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</option>';
      });
      selectHtml += '</select>';

      return '<label class="cart-rec-card__selector">' +
        '<span class="cart-rec-card__selector-label">' + label + '</span>' +
        selectHtml +
      '</label>';
    }).join('');
  }

  function findVariant(product, selectedOptions) {
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });
  }

  function updateCardState(card, product) {
    var selects = card.querySelectorAll('select[data-option-index]');
    var selectedOptions = Array.prototype.map.call(selects, function (s) { return s.value; });
    var variant = findVariant(product, selectedOptions);
    var btn = card.querySelector('.cart-rec-card__add');
    var priceEl = card.querySelector('.cart-rec-card__price');
    var compareEl = card.querySelector('.cart-rec-card__compare');

    if (!variant) {
      btn.disabled = true;
      btn.textContent = 'No disponible';
      btn.dataset.variantId = '';
      return;
    }

    btn.dataset.variantId = variant.id;
    if (!variant.available) {
      btn.disabled = true;
      btn.textContent = 'Agotado';
    } else {
      btn.disabled = false;
      btn.textContent = 'Añadir';
    }

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  function buildCard(product) {
    var card = document.createElement('div');
    card.className = 'cart-rec-card';
    card._productData = product;

    var imageUrl = getProductImageUrl(product);
    var productUrl = getProductUrl(product);
    var firstVariant = product.variants && product.variants[0];
    var hasCompareAt = firstVariant && firstVariant.compare_at_price && parseFloat(firstVariant.compare_at_price) > parseFloat(firstVariant.price);
    var safeTitle = escapeHtml(product.title);
    var imgSep = imageUrl.indexOf('?') === -1 ? '?' : '&';

    card.innerHTML = '' +
      '<a class="cart-rec-card__image" href="' + productUrl + '">' +
        (imageUrl ? '<img src="' + imageUrl + imgSep + 'width=200" alt="' + safeTitle + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="cart-rec-card__body">' +
        '<a class="cart-rec-card__name" href="' + productUrl + '">' + safeTitle + '</a>' +
        '<div class="cart-rec-card__prices">' +
          '<span class="cart-rec-card__compare" ' + (hasCompareAt ? '' : 'style="display:none;"') + '>' + (hasCompareAt ? formatMoney(firstVariant.compare_at_price) : '') + '</span>' +
          '<span class="cart-rec-card__price">' + formatMoney(firstVariant ? firstVariant.price : product.price) + '</span>' +
        '</div>' +
        '<div class="cart-rec-card__selectors">' + buildVariantSelectors(product) + '</div>' +
        '<button type="button" class="cart-rec-card__add" data-variant-id="' + (firstVariant ? firstVariant.id : '') + '" ' + (firstVariant && !firstVariant.available ? 'disabled' : '') + '>' +
          (firstVariant && !firstVariant.available ? 'Agotado' : 'Añadir') +
        '</button>' +
      '</div>';

    // Listener para cambios en los dropdowns
    card.querySelectorAll('select[data-option-index]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        updateCardState(card, product);
      });
    });

    return card;
  }

  async function addToCart(variantId, button) {
    if (pending || !variantId) return;
    pending = true;
    if (button) {
      button.disabled = true;
      button.textContent = 'Añadiendo…';
    }
    try {
      var resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!resp.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (e) {
      console.error('cart-recommendations:', e);
      if (button) {
        button.disabled = false;
        button.textContent = 'Añadir';
      }
    } finally {
      pending = false;
    }
  }

  async function loadRecommendations() {
    var container = document.querySelector('[data-cart-recommendations]');
    var list = document.querySelector('[data-cart-recommendations-list]');
    if (!container || !list) return;

    var cart = await fetchCart();
    if (!cart || cart.items.length === 0) {
      container.hidden = true;
      return;
    }

    var cartProductIds = cart.items.map(function (i) { return i.product_id; });

    // 1) Shopify Recommendations API (basada en ML)
    var data = await fetchRecommendations(cart.items[0].product_id);
    var products = (data && data.products) || [];
    products = products.filter(function (p) { return cartProductIds.indexOf(p.id) === -1; });

    // 2) Fallback: colección curada cuando la API no devuelve nada
    if (products.length === 0) {
      var fallback = await fetchFallbackCollection();
      products = (fallback || []).filter(function (p) { return cartProductIds.indexOf(p.id) === -1; });
    }

    if (products.length === 0) {
      container.hidden = true;
      return;
    }

    recProducts = products.slice(0, LIMIT);
    currentIndex = 0;
    renderCurrentCard();
    container.hidden = false;
  }

  function renderCurrentCard() {
    var list = document.querySelector('[data-cart-recommendations-list]');
    if (!list || recProducts.length === 0) return;
    list.innerHTML = '';

    var wrapper = document.createElement('div');
    wrapper.className = 'cart-rec-wrapper';

    if (recProducts.length > 1) {
      wrapper.appendChild(buildArrow('prev'));
    }
    wrapper.appendChild(buildCard(recProducts[currentIndex]));
    if (recProducts.length > 1) {
      wrapper.appendChild(buildArrow('next'));
    }

    list.appendChild(wrapper);
  }

  function buildArrow(direction) {
    var btn = document.createElement('button');
    // setAttribute('type','button') es importante: el drawer está dentro de un
    // <form> y un button sin type=button hace submit (cerrando el drawer).
    btn.setAttribute('type', 'button');
    btn.className = 'cart-rec-arrow cart-rec-arrow--' + direction;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Anterior' : 'Siguiente');
    var path = direction === 'prev' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (direction === 'prev') {
        currentIndex = (currentIndex - 1 + recProducts.length) % recProducts.length;
      } else {
        currentIndex = (currentIndex + 1) % recProducts.length;
      }
      renderCurrentCard();
    });
    return btn;
  }

  // Listener para el botón "Añadir" (event delegation)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-rec-card__add');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    addToCart(variantId, btn);
  });

  // Cargar al inicio
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRecommendations);
  } else {
    loadRecommendations();
  }

  // El theme dispara distintos eventos según la acción:
  //   - cart:build   → custom: nuestro cart-variant-switcher tras cambio de variante
  //   - ajaxProduct:added → al añadir producto desde el botón add-to-cart
  //   - cart:updated → cambios genéricos (qty, eliminar línea)
  // Hay un pequeño delay porque /cart.js tarda en reflejar la última mutación.
  function reloadSoon() {
    setTimeout(loadRecommendations, 150);
  }
  document.addEventListener('cart:build', reloadSoon);
  document.addEventListener('ajaxProduct:added', reloadSoon);
  document.addEventListener('cart:updated', reloadSoon);
})();
